import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { IContactFormProps } from '../../../interfaces/common/contactus';
import { ErrorResponse } from 'react-router-dom';
import { ApiEndPoints } from '../authentication/api-path';
import { getAPIConfig } from '../authentication/services/get-api-config';

/**
 * @description This method makes an API call to send Contact Us form data.
 */
export const contactUs = createAsyncThunk(
  'contact/contactUs',
  async (values: IContactFormProps, thunkApi) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.ContactUs}`;
      const { data } = await axios.post(url, values, await getAPIConfig());

      if (data.status === 200) {
        return thunkApi.fulfillWithValue(data);
      }
    } catch (e) {
      const error = e as AxiosError<ErrorResponse>;
      if (error.response) {
        return thunkApi.rejectWithValue(error.response.data);
      } else {
        return thunkApi.rejectWithValue('An unknown error occurred.');
      }
    }
  }
);
